import { faA, faM, faU } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from '@mui/material'
import { useTranslation } from '../../../../i18n/I18nProvider'
const CategoryIcons = ({ Category }) => {
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    return (
        Category === 'AUTHENTICATION' ?
            <Tooltip title={tr('waAuthCategory', 'AUTHENTICATION')} placement="top"> 
                <FontAwesomeIcon icon={faA} size='30px' fontSize={20} className='CategoryIcons' />
            </Tooltip>
            : Category === 'MARKETING' ?
                <Tooltip title={tr('waMarketingCategory', 'MARKETING')} placement="top">
                    <FontAwesomeIcon icon={faM} size='30px' fontSize={20} className='CategoryIcons' />
                </Tooltip>
                : Category === 'UTILITY' ?
                    <Tooltip title={tr('waUtilityCategory', 'UTILITY')} placement="top">
                        <FontAwesomeIcon icon={faU} size='30px' fontSize={20} className='CategoryIcons' />
                    </Tooltip>
                    : null
    )
}

export default CategoryIcons
